import CustomerItemEquivalencesPage from "../../pages/legacy/customerItemEquivalences/CustomerItemEquivalencesPage";

const route = {
  key: "customerItemEquivalences",
  path: "/legacy/customer-item-equivalences",
  component: CustomerItemEquivalencesPage,
  private: true,
  layout: "main",
  icon: "faLink",
  group: "sales",
  order: 23,
  permission: "legacy.customerItemEquivalences.read"
};

export default route;